import axios from '@/request'

// 基础通用接口

// 获取省份
export function getProvince() {
    return axios({
        url: 'yladmin/sys/province',
        method: 'get'
    })
}

// 获取城市
export function getCity(params) {
    return axios({
        url: 'yladmin/sys/city',
        method: 'get',
        params: params
    })
}

// 获取计费类型
export function getFeeTypeList() {
    return axios({
        url: '/operator/search/fee_type',
        method: 'get',
    })
}

// 获取支付类型列表
export function getPayTypeList() {
    return axios({
        url: '/operator/search/pay_type',
        method: 'get',
    })
}

// 获取订单状态列表
export function getOrderStatusList() {
    return axios({
        url: '/operator/search/order_status',
        method: 'get',
    })
}

// 获取支付状态列表
export function getPayStatusList() {
    return axios({
        url: '/operator/search/pay_status',
        method: 'get',
    })
}

// 通用上传
export function upload() {
    return axios({
        url: '/upload',
        method: 'post',
    })
}


